const { createTheme } = require('@mui/material');

export const customDialogAddEditCommonTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiDialog-paper': {
            border: '3px solid #e69636 !important',
            borderRadius: '20px',
            textAlign: 'center',
            fontSize: '18px',
            color: '#e69636 !important',
            width: '900px',
            height: '500px',
            maxWidth: 'unset !important',
            maxHeight: 'unset !important',
          },
          '& .MuiDialog-paper .MuiBox-root': {
            justifyContent: 'center !important',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          },
          '& .MuiDialog-paper .MuiBox-root .MuiSvgIcon-root': {
            fontSize: '36px',
            color: '#277134',
            cursor: 'pointer',
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '20px',
          color: '#e69636',
          fontFamily: 'Rubik-Bold !important',
          color: '#277134 !important',
          userSelect: 'none',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          whiteSpace: 'pre-wrap',
          display: 'flex',
          alignItems: 'center',
          maxWidth: '100%',
          flexWrap: 'wrap',
          justifyContent: 'center',
          '& > label': {
            padding: '10px',
            overflow: 'unset !important',
            maxWidth: '160px',
            whiteSpace: 'pre-wrap',
            fontFamily: 'Rubik-Medium !important',
            color: '#277134 !important',
            userSelect: 'none',
          },
          '& .MuiBox-root': {
            width: '46% !important',
            flexWrap: 'wrap',
            margin: '8px',
            '& label': {
              width: '36%',
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
              maxWidth: '160px',
              overflow: 'unset !important',
              fontFamily: 'Rubik-Medium !important',
            },
            '& label:not(.Mui-disabled)': {
              color: '#277134 !important',
            },
            '.MuiInputBase-root': {
              width: '60%',
              outline: '1px solid #e69636 !important',
              borderRadius: '4px !important',
              textAlign: 'start',
              '.custom-clear-button svg': {
                width: '24px',
                height: '24px',
                paddingLeft: 0,
                opacity: 1,
              },
              '& [data-testid="CalendarIcon"]': {
                width: '24px',
                height: '24px',
                paddingLeft: '0 !important',
              },
              ':hover': {
                outline: '2px solid #e69636 !important',
              },
              '.MuiInputBase-root': {
                width: '100% !important',
              },
              '&.Mui-error': {
                border: '2px solid #d32f2f !important',
                borderRadius: '4px !important',
                outline: 'unset !important',

                ':hover': {
                  outline: '2.5px solid #d32f2f !important',
                },
                '&.Mui-focused': {
                  outline: '2.5px solid #d32f2f !important',
                },
              },
            },
            ' .MuiInputBase-root.Mui-disabled': {
              outline: '1px solid #d2d2d2 !important',
              ' .MuiSvgIcon-root': {
                color: '#d2d2d2 !important',
                cursor: 'not-allowed !important',
              },
              ':hover': {
                outline: '1px solid #d2d2d2 !important',
              },
            },
            '& .MuiOutlinedInput-root.Mui-focused': {
              outline: '2px solid #e69636 !important',
            },
          },
          '& .Mui-disabled': {
            cursor: 'not-allowed !important',
            pointerEvents: 'unset !important',
          },
          '.Mui-disabled.dialog-checkbox .MuiSvgIcon-root': {
            color: '#d2d2d2 !important',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#d32f2f !important',
          marginLeft: '2px !important',
          letterSpacing: 'unset !important',
          fontStyle: 'italic',
          fontWeight: 'bold',
          textAlign: 'center',
          width: '100%',
          whiteSpace: 'pre-wrap !important',
          fontSize: '0.7rem',
          lineHeight: '1',
          position: 'absolute',
          top: '57px',
          bottom: '0px',
          right: '0px',
          left: '0px',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          justifyContent: 'center !important',
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '60%',
          '.MuiInputBase-root': {
            width: '100% !important',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: 'unset !important',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          textAlign: 'left',
          maxWidth: '100%',
          whiteSpace: 'pre-wrap',
        },
      },
    },
  },
});
